// extracted by mini-css-extract-plugin
export var headerNavMenu = "HeaderNavMenu_headerNavMenu__Kavhv";
export var navLink = "HeaderNavMenu_navLink__WeTFy";
export var rotate = "HeaderNavMenu_rotate__zdRF7";
export var dotty = "HeaderNavMenu_dotty__+ZIG+";